module.exports = __webpack_public_path__ + "img/couples-042.a44af65a.jpg";